"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinParams = void 0;
const string_1 = require("./string");
exports.joinParams = (paramObj) => {
    const data = [];
    Object.keys(paramObj).forEach(attr => data.push(`${attr}=${string_1.escape(paramObj[attr])}`));
    return data.join('&');
};
